import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OauthService } from '../services/oauth.service';

/**
 * Gate /synthetic behind the sas2r session. Unlike the workspace guard this does
 * not require a selected repository — a synthetic cohort is defined by a study
 * design and a parameter pack, not by a code repository.
 */
export const syntheticAccessGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const auth = inject(OauthService);
  const user = await auth.getUser();
  if (!user) {
    router.navigate(['/']);
    return false;
  }
  return true;
};
